import actions from './action'
import { transformCA } from '../../utilities/transformer'

const initialState = {
  selectedAccount: {},
  currencyAccountsList: [],
  CAlistLoading: false,
  modalVisible: false,
  addCALoading: false,
}

export default function chatReducer(state = initialState, action) {
  switch (action.type) {
    case actions.UPDATE_SELECED_ACCOUNT:
      return {
        ...state,
        selectedAccount: action.value,
      }
    case actions.GET_CURRENCY_ACCOUNTS:
      return {
        ...state,
        CAlistLoading: true,
      }

    case actions.GET_CURRENCY_ACCOUNTS_SUCCESS:
      return {
        ...state,
        currencyAccountsList: transformCA(action.value.currencyAccounts),
        CAlistLoading: false,
      }
    case actions.GET_CURRENCY_ACCOUNTS_FAILURE:
      return {
        ...state,
        currencyAccountsList: [],
        CAlistLoading: false,
      }
    case actions.SHOW_CURRENCY_LIST_MODAL:
      return {
        ...state,
        modalVisible: true,
      }
    case actions.CLOSE_CURRENCY_LIST_MODAL:
      return {
        ...state,
        modalVisible: false,
      }
    case actions.ADD_ACCOUNT_BY_CURRENCY:
      return {
        ...state,
        addCALoading: true,
      }

    case actions.ADD_ACCOUNT_BY_CURRENCY_SUCCESS:
      return {
        ...state,
        addCALoading: false,
      }
    case actions.ADD_ACCOUNT_BY_CURRENCY_FAILURE:
      return {
        ...state,

        addCALoading: false,
      }

    default:
      return state
  }
}
